// extracted by mini-css-extract-plugin
export default {"menu":"applications-components-HeaderApp-components-UserMenu-user-menu-module__menu","special":"applications-components-HeaderApp-components-UserMenu-user-menu-module__special"};
    if(module.hot) {
      // 1782397803620
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  